import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import MenuIcon from '@material-ui/icons/Menu';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import AccountCircleOutlined from '@material-ui/icons/AccountCircleOutlined';
import ExitToAppOutlined from '@material-ui/icons/ExitToAppOutlined';
import PersonOutline from '@material-ui/icons/PersonOutline';
import MenuItem from '@material-ui/core/MenuItem';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

import { Billing } from 'icons';
import { setFilters as actionSetFilters } from 'store/actions/filtersActions';
import { signOut } from 'services/helpers/signOut';
import Points from 'assets/rewards/points.png';

import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  active: {
    color: theme.palette.primary.main,
  },
  badge: {
    width: '24px',
    height: '24px',
    marginRight: theme.spacing(1),
  },
}));

// Reset sorting before open the contacts page
const contactsDefaultSearchParams = new URLSearchParams({
  page: '1',
  perPage: '10',
  sort: 'fullName',
  order: 'ASC',
  filter: '',
}).toString();

const isActive = (activeIndex) => {
  return window.location.pathname.includes(activeIndex);
};

const MobileMenu = ({ items, activeIndex }: { items: any; activeIndex: string }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await signOut();
  };

  // Reset sorting before open the contacts page
  const handleResetContactsSearchFilter = () => {
    dispatch(actionSetFilters({ resource: 'contacts', filters: { q: '' } }));
    handleClose();
  };

  return (
    <Box className={classes.container}>
      <IconButton aria-haspopup="true" onClick={handleClick}>
        <MenuIcon />
      </IconButton>
      <Popover
        disableScrollLock
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        {items.primary &&
          items.primary.map((item) => (
            <MenuItem
              onClick={handleClose}
              component={NavLink}
              to={item.path}
              className={isActive(item.path) ? classes.active : ''}>
              {item.label}
            </MenuItem>
          ))}
        {items.connections &&
          items.connections.map((item) => (
            <MenuItem
              onClick={handleClose}
              component={NavLink}
              to={item.path}
              className={isActive(item.path) ? classes.active : ''}>
              {item.label}
            </MenuItem>
          ))}
        <Divider />
        <MenuItem
          component={NavLink}
          to="/rewards"
          onClick={handleClose}
          className={isActive('rewards') ? classes.active : ''}>
          <img className={classes.badge} src={Points} alt="" />
          Rollo rewards
        </MenuItem>
        <MenuItem
          component={NavLink}
          to="/profile"
          onClick={handleClose}
          className={isActive('profile') ? classes.active : ''}>
          <AccountCircleOutlined className={classes.icon} /> Profile
        </MenuItem>
        <MenuItem
          component={NavLink}
          to="/billing"
          onClick={handleClose}
          className={isActive('billing') ? classes.active : ''}>
          <Billing className={classes.icon} /> Billing
        </MenuItem>
        <MenuItem
          component={NavLink}
          to="/shippingPresets"
          onClick={handleClose}
          className={isActive('shippingPresets') ? classes.active : ''}>
          <SettingsOutlinedIcon className={classes.icon} /> Settings
        </MenuItem>
        <MenuItem
          onClick={handleResetContactsSearchFilter}
          component={NavLink}
          to={{
            pathname: '/contacts',
            search: contactsDefaultSearchParams,
          }}
          className={isActive('contacts') ? classes.active : ''}>
          <PersonOutline className={classes.icon} /> Contacts
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ExitToAppOutlined className={classes.icon} /> Logout
        </MenuItem>
      </Popover>
    </Box>
  );
};

export default MobileMenu;
